import { map, filter } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Paragraph from 'components/Paragraph';
import SizeButton from 'components/SizeButton';
import Theme from 'styles/theme';
import { SIZE_FILTER_GROUPINGS } from 'utils/Filters';
import I18n from 'utils/I18n';

const Options = ({ options, onFilterOptionSelect }) => {
  const hasHelpText =
    filter(options, option => {
      return (
        option?.grouping === SIZE_FILTER_GROUPINGS.SHOE ||
        option?.grouping === SIZE_FILTER_GROUPINGS.UNISEX_SHOE
      );
    }).length > 0;

  return (
    <div className="CollectionFilterSelector__size-options">
      {hasHelpText && (
        <Paragraph className="CollectionFilterSelector__size-help-text">
          {I18n.localize('collectionPage.filterDescriptions.size')}
        </Paragraph>
      )}

      {map(options, ({ option, label, value }) => {
        return (
          <SizeButton
            label={label}
            key={option}
            active={value}
            options={{ isMultiline: true, isSquare: false }}
            onClick={() => onFilterOptionSelect({ option, value: !value })}
            className="CollectionFilterSelector__size-option"
          />
        );
      })}
      <style jsx>
        {`
          .CollectionFilterSelector__size-options {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
          }
        `}
      </style>

      <style jsx global>
        {`
          .CollectionFilterSelector__size-options .CollectionFilterSelector__size-option {
            width: auto;
            min-width: ${Theme.get('touch-target-size-px')};
            padding: ${Theme.get('spacing-px')} ${Theme.get('spacing') * 2}px;
            margin-right: ${Theme.get('spacing') * 1}px;
            margin-bottom: ${Theme.get('spacing') * 1}px;
          }
          .CollectionFilterSelector__size-options
            .CollectionFilterSelector__size-option:last-child {
            margin-right: 0;
          }

          .CollectionFilterSelector__size-help-text.Paragraph {
            font-size: ${Theme.get('font-size-small-px')};
          }
        `}
      </style>
    </div>
  );
};

Options.propTypes = {
  onFilterOptionSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Options;
